import { useCallback } from 'react';
import { useRouter } from 'expo-router';

import { useIsCustomerAddress } from '../../hooks';
import { useLastInteractedStore } from './useLastInteractedStore';

/**
 * Navigates to the last interacted store if available.
 * Fallback is to navigate to the menu tab itself.
 */
export const useNavigateToLastInteractedStore = (params?: Params) => {
  const router = useRouter();

  const lastInteractedStore = useLastInteractedStore();
  const { restaurantSlug = '', addressId } = lastInteractedStore ?? {};

  const isCustomerAddress = useIsCustomerAddress(addressId);

  // ─── Helpers ───────────────────────────────────────────────────────────────

  const navigateToLastInteractedStore = useCallback(() => {
    const navMethod = params?.isInsideModal ? 'dismissTo' : 'navigate';

    if (restaurantSlug) {
      router[navMethod]({ pathname: '/[restaurantSlug]/menu', params: { restaurantSlug } }); // prettier-ignore
      return;
    }

    if (addressId && isCustomerAddress) {
      router[navMethod]({ pathname: '/delivery/[addressId]/menu', params: { addressId } }); // prettier-ignore
      return;
    }

    router[navMethod]('/locations');
  }, [params?.isInsideModal, restaurantSlug, addressId, isCustomerAddress, router]);

  // ─────────────────────────────────────────────────────────────────────────────

  return navigateToLastInteractedStore;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  isInsideModal?: boolean;
};
